import { getDefaultClassNames } from "react-day-picker";

import { twMerge } from "tailwind-merge";

export const dayPickerVars: React.CSSProperties & Record<string, string> = {
  "--rdp-day-width": "24.5px",
  "--rdp-day-height": "31px",
  "--rdp-day_button-width": "31px",
  "--rdp-day_button-height": "27px",
  "--rdp-day_button-border-radius": "6px",
  "--rdp-day_button-border": "none",
  "--rdp-selected-border": "none",
  "--rdp-accent-color": "#1D1C1C",
  "--rdp-today-color": "#1D1C1C",
  "--rdp-range_start-date-background-color": "#1D1C1C",
  "--rdp-range_end-date-background-color": "#1D1C1C",
  "--rdp-range_middle-background-color": "#F3F5AE",
  "--rdp-range_middle-color": "#1D1C1C",
  "--rdp-nav_button-width": "25px",
  "--rdp-nav_button-height": "25px",
  "--rdp-nav-height": "34.5px",
  "--rdp-weekday-padding": "4.5px 0",
};

export const dayPickerStyle = `
    .tp-day-picker .rdp-day_button:hover { background-color: #F2ECEC; }
    .tp-day-picker .rdp-range_middle .rdp-day_button:hover { background-color: #E7EB5D; }
    .tp-day-picker .rdp-range_start .rdp-day_button:hover,
    .tp-day-picker .rdp-range_end .rdp-day_button:hover { background-color: #1D1C1C; }
    .tp-day-picker .rdp-disabled .rdp-day_button:hover { background-color: transparent; }
    .tp-day-picker .rdp-range_start .rdp-day_button,
    .tp-day-picker .rdp-range_end .rdp-day_button { font-weight: 700; }
    .tp-day-picker .rdp-outside.rdp-range_start,
    .tp-day-picker .rdp-outside.rdp-range_middle,
    .tp-day-picker .rdp-outside.rdp-range_end { opacity: 1; }
`;

const defaultClassNames = getDefaultClassNames();
export const dayPickerClassNames = {
  root: twMerge(defaultClassNames.root, "tp-day-picker"),
  month_caption: twMerge(
    defaultClassNames.month_caption,
    "font-dm-sans justify-center !text-[14px] !font-bold text-black",
  ),
  caption_label: twMerge(
    defaultClassNames.caption_label,
    "font-dm-sans !text-[14px] !font-bold text-black",
  ),
  button_previous: twMerge(
    defaultClassNames.button_previous,
    "!top-[5px] !h-[28px] !w-[28px] rounded-md hover:bg-[#F2ECEC]",
  ),
  button_next: twMerge(
    defaultClassNames.button_next,
    "!top-[5px] !h-[28px] !w-[28px] rounded-md hover:bg-[#F2ECEC]",
  ),
  weekday: twMerge(
    defaultClassNames.weekday,
    "font-dm-sans text-grey4 !text-[10.5px] !font-bold uppercase",
  ),
  day: twMerge(defaultClassNames.day, "!h-[34px] !w-[38px]"),
  day_button: twMerge(
    defaultClassNames.day_button,
    "font-dm-sans relative mx-auto !h-[30px] !w-[34px] !rounded-[8px] !text-[12.5px] !leading-[30px] font-medium text-black transition-colors",
  ),
  disabled: twMerge(defaultClassNames.disabled, "!text-grey3 cursor-default"),
  outside: twMerge(defaultClassNames.outside, "text-grey4"),
};
